import { hasValue } from './equality';

export const parseLatLng = (
  latStr: string | null,
  lngStr: string | null,
): { lat: number; lng: number } | null => {
  const lat = parseFloat(hasValue(latStr) ? latStr : '');
  const lng = parseFloat(hasValue(lngStr) ? lngStr : '');
  return Number.isNaN(lat) || Number.isNaN(lng) ? null : { lat, lng };
};
